// extracted by mini-css-extract-plugin
module.exports = {"table":"FeedbackOverviewPage_table__3eUbQ","tr":"FeedbackOverviewPage_tr__yTbgM","email":"FeedbackOverviewPage_email__2tGT9"};